var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgHeader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 289,
    viewBox: "0 0 1920 289",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4255_15276)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    clipPath: "url(#clip1_4255_15276)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M1553.51 289V153.682C1524.75 153.682 1524.75 109.342 1496 109.342V289H1553.51Z",
    fill: "url(#paint0_linear_4255_15276)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.41,
    d: "M1726.06 289V84.2307C1697.3 84.2307 1697.3 262.963 1668.55 263.023V289H1726.06Z",
    fill: "url(#paint1_linear_4255_15276)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M1898.61 289V45.0864C1869.86 45.0864 1869.86 83.4844 1841.11 83.4844V289H1898.61Z",
    fill: "url(#paint2_linear_4255_15276)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M1783.6 289V128.571C1754.84 128.571 1754.84 84.2606 1726.09 84.2307V289H1783.6Z",
    fill: "url(#paint3_linear_4255_15276)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.41,
    d: "M1841.1 289V83.4844C1812.35 83.4844 1812.35 128.541 1783.6 128.571V289H1841.1Z",
    fill: "url(#paint4_linear_4255_15276)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.41,
    d: "M1611.05 289V74.6165C1582.29 74.6165 1582.29 153.682 1553.54 153.682V289H1611.05Z",
    fill: "url(#paint5_linear_4255_15276)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M1673.81 289V262.575C1642.43 262.575 1642.43 70.9737 1611.11 70.9438V288.911L1673.81 289Z",
    fill: "url(#paint6_linear_4255_15276)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.41,
    d: "M1956.15 289V2.35889C1927.39 2.35889 1927.39 45.1759 1898.64 45.2058V289H1956.15Z",
    fill: "url(#paint7_linear_4255_15276)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    clipPath: "url(#clip2_4255_15276)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M57.5074 289V153.682C28.7537 153.682 28.7537 109.342 0 109.342V289H57.5074Z",
    fill: "url(#paint8_linear_4255_15276)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.41,
    d: "M230.058 289V84.2307C201.304 84.2307 201.304 262.963 172.551 263.023V289H230.058Z",
    fill: "url(#paint9_linear_4255_15276)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M402.613 289V45.0864C373.859 45.0864 373.859 83.4844 345.105 83.4844V289H402.613Z",
    fill: "url(#paint10_linear_4255_15276)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M287.597 289V128.571C258.844 128.571 258.844 84.2606 230.09 84.2307V289H287.597Z",
    fill: "url(#paint11_linear_4255_15276)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.41,
    d: "M345.105 289V83.4844C316.351 83.4844 316.351 128.541 287.598 128.571V289H345.105Z",
    fill: "url(#paint12_linear_4255_15276)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.41,
    d: "M115.046 289V74.6165C86.2928 74.6165 86.2928 153.682 57.5391 153.682V289H115.046Z",
    fill: "url(#paint13_linear_4255_15276)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M177.808 289V262.575C146.427 262.575 146.427 70.9737 115.105 70.9438V288.911L177.808 289Z",
    fill: "url(#paint14_linear_4255_15276)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.41,
    d: "M690.207 289V127.764C661.453 127.764 661.453 153.592 632.699 153.622V289H690.207Z",
    fill: "url(#paint15_linear_4255_15276)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.41,
    d: "M460.148 289V2.35889C431.394 2.35889 431.394 45.1759 402.641 45.2058V289H460.148Z",
    fill: "url(#paint16_linear_4255_15276)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M632.7 289V153.682C603.976 153.682 603.946 76.0496 575.223 76.0496V288.94L632.7 289Z",
    fill: "url(#paint17_linear_4255_15276)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M747.865 289V153.682C719.082 153.682 719.082 127.824 690.328 127.824V289.06L747.865 289Z",
    fill: "url(#paint18_linear_4255_15276)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M517.657 289V174.374C488.933 174.374 488.904 2.32908 460.18 2.2395V288.881L517.657 289Z",
    fill: "url(#paint19_linear_4255_15276)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.41,
    d: "M575.195 289V76.1094C546.441 76.1094 546.441 174.314 517.688 174.374V289H575.195Z",
    fill: "url(#paint20_linear_4255_15276)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    clipPath: "url(#clip3_4255_15276)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.41,
    d: "M1438.24 289V153.682C1466.99 153.682 1466.99 109.342 1495.75 109.342V289H1438.24Z",
    fill: "url(#paint21_linear_4255_15276)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M1265.69 289V84.2307C1294.44 84.2307 1294.44 262.963 1323.2 263.023V289H1265.69Z",
    fill: "url(#paint22_linear_4255_15276)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.41,
    d: "M1093.13 289V45.0864C1121.89 45.0864 1121.89 83.4844 1150.64 83.4844V289H1093.13Z",
    fill: "url(#paint23_linear_4255_15276)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.41,
    d: "M1208.15 289V128.571C1236.9 128.571 1236.9 84.2606 1265.66 84.2307V289H1208.15Z",
    fill: "url(#paint24_linear_4255_15276)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M1150.64 289V83.4844C1179.39 83.4844 1179.39 128.541 1208.15 128.571V289H1150.64Z",
    fill: "url(#paint25_linear_4255_15276)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M1380.7 289V74.6165C1409.45 74.6165 1409.45 153.682 1438.21 153.682V289H1380.7Z",
    fill: "url(#paint26_linear_4255_15276)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.41,
    d: "M1317.94 289V262.575C1349.32 262.575 1349.32 70.9737 1380.64 70.9438V288.911L1317.94 289Z",
    fill: "url(#paint27_linear_4255_15276)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M805.539 289V127.764C834.293 127.764 834.293 153.592 863.047 153.622V289H805.539Z",
    fill: "url(#paint28_linear_4255_15276)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M1035.6 289V2.35889C1064.35 2.35889 1064.35 45.1759 1093.11 45.2058V289H1035.6Z",
    fill: "url(#paint29_linear_4255_15276)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.41,
    d: "M863.046 289V153.682C891.77 153.682 891.8 76.0496 920.523 76.0496V288.94L863.046 289Z",
    fill: "url(#paint30_linear_4255_15276)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.41,
    d: "M747.881 289V153.682C776.664 153.682 776.664 127.824 805.418 127.824V289.06L747.881 289Z",
    fill: "url(#paint31_linear_4255_15276)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.41,
    d: "M978.089 289V174.374C1006.81 174.374 1006.84 2.32908 1035.57 2.2395V288.881L978.089 289Z",
    fill: "url(#paint32_linear_4255_15276)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M920.551 289V76.1094C949.305 76.1094 949.305 174.314 978.059 174.374V289H920.551Z",
    fill: "url(#paint33_linear_4255_15276)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4255_15276",
    x1: 1524.75,
    y1: 366.453,
    x2: 1524.75,
    y2: 41.0256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4255_15276",
    x1: 1697.3,
    y1: 320.65,
    x2: 1697.3,
    y2: 134.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4255_15276",
    x1: 1869.86,
    y1: 366.453,
    x2: 1869.86,
    y2: 41.0257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4255_15276",
    x1: 1754.84,
    y1: 366.453,
    x2: 1754.84,
    y2: 41.0255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4255_15276",
    x1: 1812.35,
    y1: 320.65,
    x2: 1812.35,
    y2: 134.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4255_15276",
    x1: 1582.26,
    y1: 320.65,
    x2: 1582.26,
    y2: 134.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4255_15276",
    x1: 1642.43,
    y1: 367.767,
    x2: 1642.43,
    y2: 36.7261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4255_15276",
    x1: 1927.39,
    y1: 320.65,
    x2: 1927.39,
    y2: 134.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4255_15276",
    x1: 28.7537,
    y1: 366.453,
    x2: 28.7537,
    y2: 41.0256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4255_15276",
    x1: 201.304,
    y1: 320.65,
    x2: 201.304,
    y2: 134.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4255_15276",
    x1: 373.859,
    y1: 366.453,
    x2: 373.859,
    y2: 41.0257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4255_15276",
    x1: 258.844,
    y1: 366.453,
    x2: 258.844,
    y2: 41.0255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4255_15276",
    x1: 316.351,
    y1: 320.65,
    x2: 316.351,
    y2: 134.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4255_15276",
    x1: 86.2629,
    y1: 320.65,
    x2: 86.2629,
    y2: 134.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4255_15276",
    x1: 146.427,
    y1: 367.767,
    x2: 146.427,
    y2: 36.7261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4255_15276",
    x1: 661.453,
    y1: 320.65,
    x2: 661.453,
    y2: 134.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4255_15276",
    x1: 431.394,
    y1: 320.65,
    x2: 431.394,
    y2: 134.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4255_15276",
    x1: 603.946,
    y1: 366.453,
    x2: 603.946,
    y2: 41.0256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4255_15276",
    x1: 718.962,
    y1: 366.453,
    x2: 718.962,
    y2: 41.0257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_4255_15276",
    x1: 488.904,
    y1: 366.453,
    x2: 488.904,
    y2: 41.0256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_4255_15276",
    x1: 546.411,
    y1: 320.65,
    x2: 546.411,
    y2: 134.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_4255_15276",
    x1: 1466.99,
    y1: 324.266,
    x2: 1466.99,
    y2: 116.794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_4255_15276",
    x1: 1294.58,
    y1: 387.289,
    x2: 1294.58,
    y2: -26.0034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_4255_15276",
    x1: 1121.89,
    y1: 336.88,
    x2: 1121.89,
    y2: 55.2043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_4255_15276",
    x1: 1236.9,
    y1: 329.195,
    x2: 1236.9,
    y2: 92.7249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_4255_15276",
    x1: 1179.53,
    y1: 387.648,
    x2: 1179.53,
    y2: -27.1516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_4255_15276",
    x1: 1409.59,
    y1: 391.904,
    x2: 1409.59,
    y2: -40.7935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_4255_15276",
    x1: 1349.29,
    y1: 331.804,
    x2: 1349.29,
    y2: 79.9892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_4255_15276",
    x1: 834.427,
    y1: 366.393,
    x2: 834.427,
    y2: 40.9659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_4255_15276",
    x1: 1064.49,
    y1: 426.588,
    x2: 1064.49,
    y2: -151.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_4255_15276",
    x1: 891.785,
    y1: 330.802,
    x2: 891.785,
    y2: 84.8831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_4255_15276",
    x1: 776.649,
    y1: 320.71,
    x2: 776.649,
    y2: 134.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_4255_15276",
    x1: 1006.83,
    y1: 345.29,
    x2: 1006.83,
    y2: 14.1348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_4255_15276",
    x1: 949.439,
    y1: 391.188,
    x2: 949.439,
    y2: -38.4968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFEFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4255_15276"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 289,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4255_15276"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 747.745,
    height: 289,
    fill: "white",
    transform: "translate(1496)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_4255_15276"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 747.745,
    height: 289,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_4255_15276"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 747.745,
    height: 289,
    fill: "white",
    transform: "matrix(-1 0 0 1 1495.75 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgHeader);
export default __webpack_public_path__ + "static/media/img-header.f7aaa562a9d4b4e32966c58f871eaace.svg";
export { ForwardRef as ReactComponent };